import React from "react";
import { useDispatch } from "react-redux";

import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import useStoreAlertsSelector from "../../../hooks/useStoreAlertsSelector";
import { hideErrorAlert } from "../../../store/actions/alerts";

import "./ErrorAlert.scss";

const ErrorAlert = () => {
  const storeAlerts = useStoreAlertsSelector();
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hideErrorAlert());
  };

  return (
    <Snackbar
      TransitionComponent={Slide}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      autoHideDuration={5000}
      className="errorAlert"
      onClose={handleClose}
      open={storeAlerts?.error?.open}
    >
      <Alert onClose={handleClose} severity="error">
        <AlertTitle>Error!</AlertTitle>
        {storeAlerts?.error?.message && storeAlerts?.error?.message}
      </Alert>
    </Snackbar>
  );
};

export default ErrorAlert;
